// extracted by mini-css-extract-plugin
export default {"table":"Table_table__uE+tV","active":"Table_active__TbEHu"};